import TrainerUserSignUp from '../feature/Login/TrainerUserSignUp'
import React from 'react'

const TrainerUserSignUpPage = () => {
  return (
    <TrainerUserSignUp />

  )
}

export default TrainerUserSignUpPage

